import { render, staticRenderFns } from "./questionnairedata.vue?vue&type=template&id=3e4d24c5"
import script from "./questionnairedata.vue?vue&type=script&lang=js"
export * from "./questionnairedata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports